import Page from "../../../modules/Core/Components/Page";
import templateDefault from "../../templates/default/pages/gifts";

export default class Gifts extends Page {
  template = templateDefault;

  onAuth() {
    this.refresh();
  }

  onLoad(data) {
    super.onLoad(data);
    this.getApp().updateWindowTitle(
      `${this.ucfirst("Gifts")} | ${this.ucfirst("window-title")}`
    );
  }
}
